export default __webpack_public_path__ + "static/media/tapicerowane9.03b6b427.jpg";